import { useSelectedTournament } from "@/context/tournamentContext";
import { TournamentLinesCompare } from "@/components/general/TournamentAnalysis/TournamentAnalysisLinesCompare";

const TournamentLinesPage = () => {
    const { tournamentId } = useSelectedTournament();

    if (!tournamentId) {
        return (
            <div className="flex-1 flex items-center justify-center">
                <p className="text-on-surface-variant text-sm">No tournament selected.</p>
            </div>
        );
    }

    return (
        <div className="flex-1 flex flex-col p-4">
            <TournamentLinesCompare tournamentId={tournamentId} />
        </div>
    );
};

export default TournamentLinesPage;
